/**
 * Persist specific properties of the store state
 *
 * @param state Current Settings state
 * @return Partial state to persist
 */
export default (state: IKeyValue) => ({
	apiVersion: state.apiVersion,
	appSettings: state.appSettings,
	deviceId: state.deviceId,
	features: state.features,
	feedStructure: state.feedStructure,
	locationDenied: state.locationDenied,
	onboardingComplete: state.onboardingComplete,
	pushToken: state.pushToken,
	pwaInstallStatus: state.pwaInstallStatus,
	useLocation: state.useLocation,
});
